import { twMerge } from 'tailwind-merge'

type ContainerProps = {
  children: React.ReactNode
  className?: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
} & ((React.ComponentPropsWithoutRef<'div'>))

const sizeStyles = {
  xs: 'max-w-[460px]',
  sm: 'max-w-[600px]',
  md: 'max-w-[900px]',
  lg: 'max-w-[1200px]',
  xl: 'max-w-[1536px]',
}

export function Container({ className, size, children }: ContainerProps) {
  className = twMerge(
    'mx-auto w-full relative px-4 md:px-6',
    sizeStyles[size || 'xl'],
    className,
  )

  return (
    <div className={className}>
      {children}
    </div>
  )
}